import { namespace } from './namespace';

export const HIGHLIGHT_QUESTION = namespace + '/HIGHLIGHT_QUESTION';
export const HIDE_HIGHLIGHT = namespace + '/HIDE_HIGHLIGHT';